/* eslint-disable */

import get from 'lodash/get';
import snakeCase from 'lodash/snakeCase';

import { consts as loginActions } from './login';
import { consts as loginAzureActions } from './login-azure';
import { consts as logoutActions } from './logout';
import { consts as signupActions } from './signup/signup-req';
import { consts as editUserActions } from '../profiles/edit-user';
import { consts as editPatientActions } from '../profiles/edit-patient';
import { consts as editProviderActions } from '../profiles/edit-provider';
import { consts as createPatientActions } from '../profiles/create-patient';
import { consts as paperworkVerifyDobActions } from '../paperwork/requests/paperwork-verify-dob';
import { consts as paperworkAppointmentSessionConsts } from '../paperwork/requests/paperwork-appointment-session';
import { INVITATION_TYPES } from '../../constants/props';
import {
  REGISTRATION_COMPLETED,
  REQUEST_PASSWORD_UPDATE,
} from '../../constants/storageKeys';
import { CIRCLES, HEALTHBOARD, SIGNUP } from '../../constants/routes';

export const invitationMethods = {
  phoneNumber: 'phone_number',
  email: 'email',
};

// actions
const LOGIN = loginActions.SUCCEED;
const LOGIN_AZURE = loginAzureActions.SUCCEED;
const LOGOUT = logoutActions.SUCCEED;
const ACCEPT_INVITATION = signupActions.SUCCEED;
const EDIT_USER = editUserActions.SUCCEED;
const CREATE_PATIENT = createPatientActions.SUCCEED;
const EDIT_PATIENT = editPatientActions.SUCCEED;
const EDIT_PROVIDER = editProviderActions.SUCCEED;
const LOGOUT_CLEAR = logoutActions.CLEAR;
const UPDATE_PASSWORD = loginActions.UPDATE_PASSWORD;
const PAPERWORK_FLOW_DOB_VERIFIED = paperworkVerifyDobActions.SUCCEED;
const PAPERWORK_FLOW_AUTHORIZED_VERIFIED =
  paperworkAppointmentSessionConsts.SUCCEED;

// retrieved data
const authenticationToken = window.storage.getItem('authenticationToken');
const loggedIn = window.storage.getItem('loggedIn');
const organizationId = window.storage.getItem('organizationId');
const communityId = window.storage.getItem('communityId');
const isFamilyMemberInvitation = window.storage.getItem(
  'isFamilyMemberInvitation',
);
const isCommunityMemberInvitation = window.storage.getItem(
  'isCommunityMemberInvitation',
);
const invitationType = window.storage.getItem('invitationType');
const isRegistrationCompleted = window.storage.getItem(REGISTRATION_COMPLETED);
const isRequestPasswordUpdate = window.storage.getItem(REQUEST_PASSWORD_UPDATE);

const initialState = {
  authenticationToken: authenticationToken
    ? JSON.parse(authenticationToken)
    : null,
  requestPasswordUpdate: isRequestPasswordUpdate
    ? JSON.parse(isRequestPasswordUpdate)
    : true,
  registrationCompleted: isRegistrationCompleted
    ? JSON.parse(isRegistrationCompleted)
    : false,
  loggedIn: loggedIn ? JSON.parse(loggedIn) : false,
  organizationId: organizationId ? JSON.parse(organizationId) : null,
  communityId: communityId ? JSON.parse(communityId) : null,
  isFamilyMemberInvitation: isFamilyMemberInvitation
    ? JSON.parse(isFamilyMemberInvitation)
    : false,
  invitationType: invitationType ? JSON.parse(invitationType) : false,
  isCommunityMemberInvitation: isCommunityMemberInvitation
    ? JSON.parse(isCommunityMemberInvitation)
    : false,
};

const logoutState = {
  authenticationToken: null,
  loggedIn: false,
  organizationId: null,
  communityId: null,
  loggedUserId: null,
  isFamilyMemberInvitation: false,
  invitationType: null,
  isCommunityMemberInvitation: false,
  requestPasswordUpdate: false,
  registrationCompleted: false,
};

const handleLogin = (state, payload) => {
  const {
    user,
    authenticationToken,
    requestPasswordUpdate,
    registrationCompleted,
  } = payload;
  const { id } = user;
  return {
    ...state,
    ...{
      authenticationToken,
      registrationCompleted,
      requestPasswordUpdate,
      loggedIn: !requestPasswordUpdate && registrationCompleted,
      loggedUserId: id,
    },
  };
};

const handleAccept = (state, payload) => {
  const {
    context,
    authentication,
    organizationId,
    communityId,
    type: invitationMethod,
  } = payload;
  const authenticationToken = get(authentication, 'authenticationToken', null);
  const isFamilyMemberInvitation =
    context === snakeCase('familyMemberInvitation');
  const isCommunityMemberInvitation =
    context === snakeCase('communityMemberInvitation');
  const invitationType = context;

  let loggedIn = false;
  let redirectTo = SIGNUP;

  if (
    [INVITATION_TYPES.PATIENT, INVITATION_TYPES.PROVIDER].includes(
      invitationType,
    ) &&
    authentication.registrationCompleted
  ) {
    loggedIn = true;
    redirectTo = HEALTHBOARD;
  }

  const newState = {
    ...state,
    authenticationToken,
    organizationId,
    communityId,
    isFamilyMemberInvitation,
    redirectTo,
    loggedIn,
    invitationType,
    invitationMethod,
    isCommunityMemberInvitation,
    registrationCompleted: true,
  };

  return newState;
};

const handleUser = (state, payload) => {
  let {
    isFamilyMemberInvitation,
    loggedIn,
    redirectTo,
    isCommunityMemberInvitation,
  } = state;

  // avoid updating user profile in logged mode
  if (!loggedIn) {
    const primaryPatientProfile = get(payload, 'primaryPatientProfile', null);
    const needToCreatePatient =
      (isFamilyMemberInvitation || isCommunityMemberInvitation) &&
      !primaryPatientProfile;
    loggedIn = !needToCreatePatient;
    redirectTo = HEALTHBOARD;
  }

  const newState = {
    ...state,
    loggedIn,
    redirectTo,
  };

  return newState;
};

const handlePatientProfile = state => {
  let { loggedIn } = state;

  // avoid updating patient profile in logged mode
  if (!loggedIn) {
    loggedIn = true;
  }

  const newState = {
    ...state,
    loggedIn,
    redirectTo: CIRCLES,
    organizationId: null,
    communityId: null,
    registrationCompleted: true,
    isFamilyMemberInvitation: null,
    isCommunityMemberInvitation: null,
  };

  return newState;
};

const handleProviderProfile = state => {
  const newState = {
    ...state,
    loggedIn: true,
    redirectTo: HEALTHBOARD,
  };

  return newState;
};

const updatePassword = state => {
  return {
    ...state,
    registrationCompleted: true,
    requestPasswordUpdate: false,
  };
};

const handlePaperworkFlowLogin = (state, payload) => {
  const { authenticationToken, user } = payload;

  const { id } = user;

  return {
    ...state,
    authenticationToken,
    loggedIn: true,
    loggedUserId: id,
    registrationCompleted: true,
    requestPasswordUpdate: false,
  };
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case LOGIN_AZURE:
    case LOGIN:
      return handleLogin(state, payload);
    case UPDATE_PASSWORD:
      return updatePassword(state);
    case LOGOUT:
    case LOGOUT_CLEAR:
      return logoutState;
    case ACCEPT_INVITATION:
      return handleAccept(state, payload);
    case EDIT_USER:
      return handleUser(state, payload);
    case CREATE_PATIENT:
    case EDIT_PATIENT:
      return handlePatientProfile(state);
    case EDIT_PROVIDER:
      return handleProviderProfile(state);
    case PAPERWORK_FLOW_AUTHORIZED_VERIFIED:
    case PAPERWORK_FLOW_DOB_VERIFIED:
      return handlePaperworkFlowLogin(state, payload);
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/auth/status.js